import { CSSProperties } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const AddonSkeleton = () => {
  const styles = {
    '--base-color': '#F5F5F5',
    '--highlight-color': '#FFFFFF',
  } as CSSProperties;
  return (
    <div className="flex flex-wrap w-full gap-8">
      <div className="flex flex-wrap w-full gap-4">
        <Skeleton containerClassName="w-full" className="h-10" style={styles} />
        <div className="flex flex-wrap w-full gap-2">
          <Skeleton containerClassName="w-full" className="h-[18px]" style={styles} />
          <Skeleton containerClassName="w-full" className="h-[18px]" style={styles} />
        </div>
      </div>
      <div className="flex flex-wrap w-full gap-4">
        <Skeleton containerClassName="w-full" className="h-24" style={styles} />
        <Skeleton containerClassName="w-full" className="h-9" style={styles} />
        <Skeleton containerClassName="w-full" className="h-[18px]" style={styles} />
      </div>
    </div>
  );
};
